import { FC } from "react"

import { DynamicInputProps } from "../types"



const CheckboxInputComp: FC<DynamicInputProps> = ({ label, name, data_required, render_condition, display, isHidden, id, group, state, updateValue }): JSX.Element => {
  return display ? (
    <div className={`row py-3 ${render_condition !== "" ? "bg-light" : ""} ${isHidden ? "d-none" : ""}`}>
      <label htmlFor={`precert[${name}]`} className="col-sm-6 form-label precert-form-label">
        {label} {data_required && "*"}
      </label>
      <div className="col-sm-6">
        <div className="form-check form-check-inline">
          <input
            className="form-check-input"
            type="checkbox"
            name={name} id={name}
            required={data_required}
            checked={state[name] === "Yes"}
            onChange={(e) =>
              updateValue(e.target.checked ? "Yes" : "No", id, group)
            }
          />
          {/* <label className="form-check-label" htmlFor={`${name}${index}`}>
            {answer.trim()}
          </label> */}
        </div>
      </div>
    </div>
  ) : <></>;
}

export default CheckboxInputComp
